import React from "react";
import { LoadingButton } from '@mui/lab';
import CircularProgress from '@mui/material/CircularProgress';

const ReusableButton = ({
  variant = "contained",
  classNames,
  onClick,
  children,
  sx = {},
  loader,
  disabled,
  startIcon,
  endIcon,
  fullWidth = false,
  ...props
}) => {
  return (
    <LoadingButton
      variant={variant}
      className={classNames}
      loading={loader}
      onClick={onClick}
      sx={{ textTransform: "capitalize", ...sx }}
      disabled={disabled}
      startIcon={startIcon}
      fullWidth={fullWidth}
      endIcon={endIcon}
      {...props}
    >
      {loader ? <CircularProgress size="20px" color="inherit" /> : children}
    </LoadingButton>
  );
};

export default ReusableButton;
